import { ClassImporterExporter, ImportMap } from "@app/shared/resources/class-importer-exporter.service";
import { Command, CommandData, CommandHelper, CommandProviders } from "./command";

import { ConditionProviders } from "../conditions/condition";

export interface EmailCommand extends Command {
    notificationText: string;
    notificationSubject: string;
    recipients: { [key: number]: string };
}

export interface EmailCommandData extends CommandData {
    "notification.text": string;
    "notification.subject": string;
    recipients: { [key: number]: string };
}

export class EmailCommandHelper extends CommandHelper {
    static isValid(command: EmailCommand): boolean {
        return !!(Object.values(command.recipients).length && command.notificationText.length);
    }

    static readonly importMap: ImportMap<EmailCommand, EmailCommandData> = [
        { i: "name", o: "name" },
        { i: "command_id", o: "commandId" },
        { i: "command_type", o: "commandType" },
        { i: "notification.text", o: "notificationText" },
        { i: "notification.subject", o: "notificationSubject" },
        { i: "recipients", o: "recipients" },
    ];

    static fromCHObject(command, steps?): EmailCommand {
        return ClassImporterExporter.importObject(command, this.importMap);
    }

    static exportObject(rule, command, importMap) {
        if (command.notificationText.includes("${")) {
            if (
                rule.condition.conditionType === ConditionProviders.MULTI ||
                rule.condition.conditionType === ConditionProviders.PROPERTY_CHANGE
            ) {
                command.notificationSubject = "A smart home device event occurred";
                command.notificationText = "A device event occurred on your smarthome system: ${eventString} at ${event.time}";
            } else if (rule.condition.conditionType === ConditionProviders.UI_CONDITION) {
                command.notificationText = "The " + rule.name + " scene was run (${event.time})";
                command.notificationSubject = "A smart home scene was run";
            } else {
                command.notificationText = "The " + rule.name + " schedule was run (${event.time})";
                command.notificationSubject = "A smart home schedule was run";
            }
        }

        return ClassImporterExporter.exportObject(command, importMap, false);
    }

    static getDefault(): EmailCommand {
        return {
            name: "Send Email Notification",
            commandId: null,
            commandType: CommandProviders.EMAIL,
            notificationSubject: "A smart home device event occurred",
            notificationText: "${default}",
            recipients: {},
        };
    }

    isValid(command: EmailCommand) {
        return EmailCommandHelper.isValid(command);
    }
}
